export enum EventStatus {
  PENDING= 'PENDING',
  ACTIVE= 'ACTIVE',
  ADJUSTMENT = 'ADJUSTMENT',
  CLOSED = 'CLOSED',
  PREDELETE = 'PREDELETE'
}

export enum ComplaintStatus {
  PENDING = 'PENDING',
  CLOSED = 'CLOSED'
}

export enum UserStatus {
  ACTIVATING = 'ACTIVATING',
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED'

}
